/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignResponse
 */
export interface SignResponse {
    /**
     * 
     * @type {string}
     * @memberof SignResponse
     */
    token: string;
}

export function SignResponseFromJSON(json: any): SignResponse {
    return SignResponseFromJSONTyped(json, false);
}

export function SignResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function SignResponseToJSON(value?: SignResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}


